import React, { useCallback } from "react";

import { useHistory } from "react-router-dom";

import { Box, Button, Card, InlineStack, Text } from "@shopify/polaris";

import AdminClientOpportunityList from "../../../../components/Admin/Client/OpportunityList";

export function AccountOpportunities({ client }) {
  const history = useHistory();

  const handleCreateOpportunity = () => {
    history.push({
      pathname: "/opportunity/new",
      state: { clientId: client.id },
    });
  };

  const handleOpportunityClick = (opportunity) => {
    navigateToOpportunityShow(client.id, opportunity.id);
  };

  const navigateToOpportunityShow = useCallback(
    (clientId, opportunityId) => {
      history.push(`/clients/${clientId}/opportunities/${opportunityId}`);
    },
    [history]
  );

  const opportunitiesResourceList = (
    <AdminClientOpportunityList
      onCreateOpportunity={handleCreateOpportunity}
      onOpportunityClick={handleOpportunityClick}
      clientId={client.id}
    />
  );

  return (
    <>
      {client && client.attributes.type != "Lender" && (
        <Card padding="0">
          <Box padding="400">
            <InlineStack align="space-between">
              <Text variant="headingMd" as="h2">
                Opportunities
              </Text>
              <Button onClick={handleCreateOpportunity} variant="plain">
                Create opportunity
              </Button>
            </InlineStack>
          </Box>
          <Box>{opportunitiesResourceList}</Box>
        </Card>
      )}
    </>
  );
}
